const USER_NAME = "user_name";
const ORDER_INFO = "order_info";
export default {
    saveUserName(userName){
        window.localStorage.setItem(USER_NAME,JSON.stringify(userName));
    },
    getUserName(){
        return JSON.parse(window.localStorage.getItem(USER_NAME));
    },
    removeUserName(){
        window.localStorage.removeItem(USER_NAME);
    },
    saveOrderInfo(orderInfo){
        window.localStorage.setItem(ORDER_INFO,JSON.stringify(orderInfo));
    },
    getOrderInfo(){
        return JSON.parse(window.localStorage.getItem(ORDER_INFO));
    },
}


// WEBPACK FOOTER //
// ./src/utils/storage.js